export default __webpack_public_path__ + "static/media/logo-gray.7666fa1a.png";